module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAYAAAD/Rn+7AAAAPklEQVRIx2NgmJX8n1R848PzY/9JBcdXHvvfZPufVMww6sBRB446cNSBow4cdeCoA0cdOOrAUQeOOnA4OxAAt2sN9DbO3oAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ie.png
// module id = 840
// module chunks = 0